import { render, staticRenderFns } from "./BlocosAnuncios.vue?vue&type=template&id=19004ddc"
import script from "./BlocosAnuncios.vue?vue&type=script&lang=js"
export * from "./BlocosAnuncios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports